import React, { useState, useEffect } from 'react';
import { RefreshCw, Zap, Settings, Monitor } from 'lucide-react';

const DevTools: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [buildTime, setBuildTime] = useState<string>('');
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());

  useEffect(() => {
    // Afficher les outils de dev seulement en mode développement
    if (import.meta.env.DEV) {
      setIsVisible(true);
      setBuildTime(new Date().toLocaleString('fr-FR'));
      
      // Mettre à jour le timestamp toutes les secondes
      const interval = setInterval(() => {
        setLastUpdate(new Date());
      }, 1000);
      
      return () => clearInterval(interval);
    }
  }, []);

  const forceReload = () => {
    console.log('🔄 Rechargement forcé...');
    window.location.reload();
  };

  const clearCache = () => {
    console.log('🧹 Nettoyage du cache...');
    localStorage.clear();
    sessionStorage.clear();
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    window.location.reload();
  };

  const toggleHMR = () => {
    console.log('⚡ Hot Module Replacement status:', import.meta.hot ? 'Actif' : 'Inactif');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <div className="bg-black bg-opacity-80 text-white rounded-lg p-3 text-xs space-y-2 max-w-xs">
        <div className="flex items-center space-x-2 mb-2">
          <Monitor className="w-4 h-4 text-green-400" />
          <span className="font-semibold">Dev Tools</span>
        </div>
        
        <div className="space-y-1 text-gray-300">
          <div>Build: {buildTime}</div>
          <div>Update: {lastUpdate.toLocaleTimeString('fr-FR')}</div>
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <span>HMR: {import.meta.hot ? 'Actif' : 'Inactif'}</span>
          </div>
        </div>
        
        <div className="flex space-x-2 pt-2 border-t border-gray-600">
          <button
            onClick={forceReload}
            className="flex items-center space-x-1 px-2 py-1 bg-blue-600 hover:bg-blue-700 rounded text-xs transition-colors"
            title="Rechargement forcé"
          >
            <RefreshCw className="w-3 h-3" />
            <span>Reload</span>
          </button>
          
          <button
            onClick={clearCache}
            className="flex items-center space-x-1 px-2 py-1 bg-red-600 hover:bg-red-700 rounded text-xs transition-colors"
            title="Vider le cache"
          >
            <Settings className="w-3 h-3" />
            <span>Cache</span>
          </button>
          
          <button
            onClick={toggleHMR}
            className="flex items-center space-x-1 px-2 py-1 bg-yellow-600 hover:bg-yellow-700 rounded text-xs transition-colors"
            title="Vérifier HMR"
          >
            <Zap className="w-3 h-3" />
            <span>HMR</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DevTools;